export default __webpack_public_path__ + "static/media/ExtendBI.a14df2e7.png";